import { render, staticRenderFns } from "./BarChartPDF.vue?vue&type=template&id=4348d966&"
import script from "./BarChartPDF.vue?vue&type=script&lang=js&"
export * from "./BarChartPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports